(() => {
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  function initReportWhyBuy(section) {
    if (!section || section.dataset.motionInitialized === 'true') return;
    section.dataset.motionInitialized = 'true';

    if (reduceMotion.matches || !('IntersectionObserver' in window)) {
      section.classList.add('is-in-view');
      section.querySelectorAll('.rpt-why__feature, .rpt-why__promise, .rpt-inside__content, .rpt-why__area')
        .forEach((item) => item.classList.add('is-visible'));
      return;
    }

    section.classList.add('is-motion-ready');

    const sectionObserver = new IntersectionObserver((entries, observer) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-in-view');
        observer.unobserve(entry.target);
      });
    }, { threshold: 0.16 });

    const itemObserver = new IntersectionObserver((entries, observer) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      });
    }, { threshold: 0.18, rootMargin: '0px 0px -6% 0px' });

    sectionObserver.observe(section);
    section.querySelectorAll('.rpt-why__feature, .rpt-why__promise, .rpt-inside__content, .rpt-why__area')
      .forEach((item) => itemObserver.observe(item));
  }

  function initAll(scope = document) {
    scope.querySelectorAll('[data-report-why-buy]').forEach(initReportWhyBuy);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll(), { once: true });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();
